import React, { Component } from 'react';
import { TreeSelect, message } from 'antd';
import config from '@/commons/config-hoc';
import { getLoginUser } from '@/commons';

@config({ ajax: true })
export default class OrganizationSelect extends Component {
    state = { treeData: [] };

    componentDidMount() {
        this.mounted = true;
        this.props.action.userorganization.getOrganizeTree({
            params: { companyId: getLoginUser().companyId },
            options: { method: 'GET', withCredentials: false, contentType: 'application/json' },
            onResolve: (data) => {
                if (!this.mounted) return;
                const formatTree = nodes => nodes.map(node => ({
                    title: node.name,
                    value: node.id,
                    key: node.id,
                    children: node.childrens ? formatTree(node.childrens) : []
                }));
                const treeData = [
                    {
                        title: '全部机构',
                        value: 'all',
                        key: 'all',
                    },
                    ...formatTree(data)
                ];
                this.setState({ treeData: treeData});
                if (data.length && this.props.value === null) {
                    this.props.onChange && this.props.onChange(treeData[0].value);
                }
            },
            onReject: (error) => {
                if (this.mounted) message.error(error && error.msg ? error.msg : error);
            },
        });
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        const { value, onChange, style, label } = this.props;
        return (
            <>
                {label && <span style={{ marginRight: 8 }}>{label}：</span>}
                <TreeSelect
                    value={value}
                    onChange={onChange}
                    treeData={this.state.treeData}
                    treeDefaultExpandAll
                    showSearch
                    treeNodeFilterProp="title"
                    style={style || { width: 150 }}
                />
            </>
        );
    }
}
